export default "__VITE_ASSET__D_XbTw_F__"